import styled, { css } from 'styled-components';

interface IDivider {
  $spacing?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 8 | 10 | 12 | 14 | 16;
  negativeFill?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 8 | 10 | 12 | 14 | 16;
}

const Divider = styled.hr<IDivider>`
  border: none;
  background: ${({ theme }) => theme.color.border.neutral.default};
  height: ${({ theme }) => theme.border.width.thinner};

  ${({ $spacing, theme }) =>
    $spacing &&
    css`
      margin-top: ${`${theme.spacing[`km${$spacing}`]}`};
      margin-bottom: ${`${theme.spacing[`km${$spacing}`]}`};
    `}

  ${({ negativeFill, theme }) =>
    negativeFill &&
    css`
      margin-left: ${`-${theme.spacing[`km${negativeFill}`]}`};
      margin-right: ${`-${theme.spacing[`km${negativeFill}`]}`};
    `}
`;

export default Divider;
